import React, {useRef} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {createRoot} from 'react-dom/client';
import LearningWrapper from './LearningWrapper';
import EnvironmentProvider from '@sdb/ui/components/providers/Environment/Environment.provider';
import './aca-app';
import type {AcaAppElement} from './types/AcaAppElement';

// Create a React functional component to handle the logic
const App: React.FC = () => {
    const litRef = useRef<AcaAppElement | null>(null);

    return (
        <EnvironmentProvider appName="learning">
            <BrowserRouter>
                <LearningWrapper litRef={litRef}>
                    <aca-app ref={litRef}></aca-app>
                </LearningWrapper>
            </BrowserRouter>
        </EnvironmentProvider>
    );
};

// Store the initial value (likely null/undefined)
let announcekitValue = window.announcekit;

// Define a custom property descriptor for window.announcekit
Object.defineProperty(window, 'announcekit', {
    get: function () {
        return announcekitValue;
    },
    set: function (newValue) {
        const originalPush = newValue.push;
        newValue.push = function (...args: any[]) {
            if (args[0].boosters === false) {
                args[0].boosters = true;
            }
            return originalPush.apply(newValue, args);
        };

        // Store the (possibly modified) value
        announcekitValue = newValue;

        // You could also trigger other actions here
        // For example, call a function that does something with the new announcekit object
    },
    configurable: true,
});

// Find the root container and render the App component
const container = document.getElementById('root') as HTMLElement | null;

if (container) {
    const root = createRoot(container);

    root.render(<App />);
} else {
    console.error('Root element not found');
}
